import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Gallery from 'react-photo-gallery';
import { Card, Modal } from 'antd';

import { postRequest } from '../../services/requestService';
import { showErrorToast } from '../../services/notificationsService';
import { Spinner } from '../../components/Spinner';
import { Page } from '../../components/layout';

import './index.scss';
import { reportScreen } from '../../services/analyticsService';

const PhotosPage = () => {
  const [photos, setPhotos] = useState([]);
  const [isFetchingPhotos, setIsFetchingPhotos] = useState(false);
  const [address, setAddress] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const { dealSubmissionId } = useParams();

  const history = useHistory();

  useEffect(() => {
    const handleRedirect = (redirectUrl) => {
      window.location.href = redirectUrl;
    };

    const handleNoPhotos = (propertyAddress) => {
      history.push('/');
      setIsFetchingPhotos(false);
      showErrorToast(
        `Unfortunately there are no photos uploaded for ${propertyAddress}`,
      );
    };

    const handleSuccess = (propertyAddress, propertyPhotos) => {
      setAddress(propertyAddress);
      setPhotos(propertyPhotos);
      setIsFetchingPhotos(false);
    };

    const handleFetchError = () => {
      history.push('/');
      setIsFetchingPhotos(false);
      showErrorToast('Fetching property photos failed!');
    };

    const handleResponse = (response) => {
      if (response?.data?.redirectUrl) {
        handleRedirect(response.data.redirectUrl);
      } else if (!response?.data?.items.length) {
        handleNoPhotos(response.data.propertyAddress);
      } else {
        handleSuccess(response.data.propertyAddress, response.data.items);
      }
    };
    const fetchData = async () => {
      try {
        setIsFetchingPhotos(true);
        const response = await postRequest('/offer/get-property-photos', {
          id: dealSubmissionId,
        });

        handleResponse(response);
      } catch (error) {
        handleFetchError();
      }
    };

    fetchData();
    reportScreen('deal_photos_page');
  }, []);

  const gallerySource = photos.map((url) => ({
    src: url,
    width: 1,
    height: 1,
  }));

  return (
    <Page className="photos-page">
      <Card className={isFetchingPhotos ? 'photos-card' : ''}>
        {isFetchingPhotos ? (
          <Spinner classname="photos-spinner" />
        ) : (
          <>
            <div className="go-back-container">
              {/* <Link className="back-btn" to="/">
                <MdArrowBack />
              </Link> */}
              <h2 className="property-address">{address}</h2>
            </div>
            <Gallery
              photos={gallerySource}
              onClick={(e) => {
                setImagePreview(e.target.src);
              }}
            />
          </>
        )}
      </Card>
      <Modal
        open={Boolean(imagePreview)}
        onCancel={() => setImagePreview('')}
        footer={null}
      >
        <img
          alt="property"
          className="property-image-preview"
          src={imagePreview}
        />
      </Modal>
    </Page>
  );
};
export default PhotosPage;
